export default "__VITE_ASSET__BXU069BO__"